import styled, { DefaultTheme, css } from 'styled-components';

export const DesktopOnly = styled.div`
  display: block;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.globalWhite100};
    border: 1px solid ${theme.colors.neutralSilver10};
    border-radius: 8px;
    display: inline-block;

    @media (max-width: 768px) {
      background-color: transparent;
      display: block;
      border: none;
      border-radius: 0;
    }
  `}
`;

export const THead = styled.thead`
  ${({ theme }) => css`
    td {
      color: ${theme.colors.neutralSilver60};
    }
  `}
`;

export const Table = styled.table`
  ${({ theme }) => css`
    thead > tr {
      height: 60px;
    }

    tbody > tr {
      height: 70px;
      border-top: 1px solid ${theme.colors.neutralSilver10};
    }

    td {
      width: 120px;
      text-align: center;
      font-size: 1.4rem;
      font-weight: 500;

      > img,
      svg {
        max-width: 112px;
      }
    }
  `}
`;

export const MobileTable = styled.table`
  width: 100%;

  thead > tr {
    height: 62px;
  }

  td {
    width: 33.3%;
    height: 50px;
    padding: 0 14px;
    font-size: 1.4rem;
    font-weight: 500;

    > img,
    svg {
      max-width: 96px;
    }
  }

  @media (max-width: 360px) {
    td {
      > img,
      svg {
        max-width: 70px;
      }
    }
  }
`;

export const SCRow = styled.tr`
  ${({ theme }) => css`
    color: ${theme.colors.neutralSilver80};
  `}
`;

export const TraditionalRow = styled.tr`
  ${({ theme }) => css`
    color: ${theme.colors.neutralSilver60};
  `}
`;

export const LogoCell = styled.td`
  width: auto;
  padding: 0 24px;
`;

export const SCSavings = styled.td`
  ${({ theme }) => css`
    color: ${theme.colors.statusSuccess30};
    font-weight: 600;

    @media (max-width: 768px) {
      border-left: 1px solid ${theme.colors.neutralSilver10};
    }
  `}
`;

export const TraditionalSavings = styled.td`
  ${({ theme }) => css`
    color: ${theme.colors.statusDanger40};
    font-weight: 600;

    @media (max-width: 768px) {
      border-left: 1px solid ${theme.colors.neutralSilver10};
    }
  `}
`;

export const TitleCell = styled.td`
  ${({ theme }) => css`
    color: ${theme.colors.neutralSilver60};
  `}
`;

type ValueCellProps = {
  variant: 'sc' | 'traditional';
};

const ValueCellModifiers = {
  sc: (theme: DefaultTheme) => css`
    color: ${theme.colors.neutralSilver80};
  `,
  traditional: (theme: DefaultTheme) => css`
    color: ${theme.colors.neutralSilver60};
  `,
};

export const ValueCell = styled.td<ValueCellProps>`
  ${({ theme, variant }) => css`
    border-left: 1px solid ${theme.colors.neutralSilver10};

    span {
      display: block;
      text-align: center;
      margin-left: -14px;
    }

    ${variant && ValueCellModifiers[variant](theme)}
  `}
`;
